import React from 'react'
import { useParams } from 'react-router-dom'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const CertificateDetails = React.lazy(() => loadComponent('certification', 'CertificateDetails'))

export function CertificateDetailsRoute() {
    const params = useParams()

    return (
        <RouteContainer>
            <CertificateDetails _id={params._id} />
        </RouteContainer>
    )
}
